import dayjs from 'dayjs';

import { getDateOfMonth } from './getDateOfMonth';

const getAbsoluteDaysDiff = (start: string, end: string): number => {
  const startDate = getDateOfMonth(start);
  const diff = getDateOfMonth(end) - startDate;

  if (diff >= 0) {
    return diff;
  }

  const daysInLastFullMonth = dayjs(end).subtract(1, 'month').daysInMonth();

  if (daysInLastFullMonth < startDate) {
    return diff + startDate;
  }

  return daysInLastFullMonth + diff;
};

export { getAbsoluteDaysDiff };
